import React from 'react';

import styles from './list-tile-column.scss';

export const ListTileColumn: React.FC<React.PropsWithChildren> = ({
  children
}) => {

  return <div className={styles.tileColumn}>
    {children}
  </div>;
};
